export enum RowStatus {
  ALL = 'All',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN PROGRESS',
  ON_HOLD = 'ON HOLD',
  RECEIVED = 'RECEIVED',
  SUBMITTED = 'SUBMITTED',
}

export const statusMap = new Map();
statusMap.set('ON HOLD', 'ON_HOLD');
statusMap.set('IN PROGRESS', 'IN_PROGRESS');
